<template>
  <div>
    <div
      v-if="exit"
      v-html="template"
      @click.stop="handleButton(index, row, {event: event}, searchData)"
    ></div>
    <div
      v-else
    >
      {{rowName}}
    </div>
    <el-dialog
      :title="title"
      :visible.sync="showDialog"
      width="50%"
      center>
      <report
        v-bind="meta"
        :isDialog="inDialog"
        :code="name"
        style="height: 600px"
        ref="customdialogReport"
      ></report>
    </el-dialog>
  </div>
</template>
<script>
  import dialogReport from '../../../report/index.vue'
  import Handlebars from 'handlebars'
  import columnsMixin from '../../../../mixins/columnsMixin'
  export default {
    name: 'custom-column',
    props: {
      row: Object,
      column: Object | String,
      index: Number,
      columnTemplate: String,
      event: Object,
      name: String
    },
    mixins: [columnsMixin],
    component: {
      'dialog-report': dialogReport
    },
    data() {
      this.inDialog = true
      return {
        rowName: '-'
      }
    },
    methods: {
    },
    computed: {
      template() {
        const template = this.event.template
        let message = ''
        if (template) {
          const temp = Handlebars.compile(template)
          message = temp(this.row)
          // console.log(this.row)
          // const name = template.match(/\${(\S*)\}/)
          // const value = this.row[name[1]]
          // message = _.replace(template, name[0], value)
        } else {
          message = this.row[this.name]
        }
        return message
      },
      title() {
        return this.row[this.name]
      },
      exit() {
        // if (this.row[this.name] && this.row[this.name] !== '-') {
        //   return true
        // } else if (this.row[this.name] && this.event && this.event.sign && this.event.sign.indexOf(_this.row[_this.name]) === -1) {
        //   console.log('hahha ')
        //   return false
        // } else {
        //   return false
        // }
        if (this.row[this.name] && this.row[this.name] === '-') {
          this.rowName = this.row[this.name]
          return false
        } else if (this.row[this.name] && this.event && this.event.sign && this.event.sign.indexOf(this.row[this.name]) !== -1) {
          this.rowName = this.row[this.name]
          return false
        } else {
          return true
        }
      }
    }
  }
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/report/components/base/customColumn.vue